import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriangleLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.64645 11.6464L14.4393 5.8535C14.7543 5.53852 15.2929 5.7616 15.2929 6.20706V17.7928C15.2929 18.2383 14.7543 18.4614 14.4393 18.1464L8.64645 12.3535C8.45118 12.1582 8.45118 11.8417 8.64645 11.6464Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgTriangleLeft;
